import axios from 'axios'

const URL = 'api/item-pedido/estornar'

class PedidoApiClient {
	async buscarDetalhesEstornoItemPedido(input) {
		const { data } = await axios.get(`${URL}/historico`, { params: input })
		return data
	}
	async estornar(estornarItemPedidoInput) {
		return await axios.put(`${URL}`, estornarItemPedidoInput)
	}
}

export default new PedidoApiClient()
